import { createContext } from 'react';
import type { SessionId, StateId } from '@/types/v2';

interface State {
  id: number;
  code: string;
  name: string;
}

interface StateYearContextType {
  currentStateId: StateId | null;
  currentYear: number | null;
  currentSessionId: SessionId | null;
  states: State[];
  years: number[];
  setCurrentStateId: (stateId: StateId | null) => void;
  setCurrentYear: (year: number | null) => void;
  isPremium: boolean;
  loading: boolean;
  error: string | null;
}

export const StateYearContext = createContext<StateYearContextType | undefined>(undefined);
